import React from 'react';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import EmailSharpIcon from '@mui/icons-material/EmailSharp';
import { ADVISOR_AVAILABILITY } from 'libs/constants';

type CallButtonProps = {
  callAvailability: number;
  pmode: boolean;
  displayPrice: boolean;
  listingId: number;
  returnUrl: string;
  cancelUrl: string;
  webTrack: number;
  majorRank: number;
  flBidId: number;
  eligibleForFeaturedListingClicks: boolean;
  parentCategoryId: number;
  appointmentTargetUri: string;
  onCallButtonClick?: any;
};

export default function CallButton({
  callAvailability,
  pmode,
  displayPrice,
  listingId,
  returnUrl,
  cancelUrl,
  webTrack,
  majorRank,
  flBidId,
  eligibleForFeaturedListingClicks,
  parentCategoryId,
  appointmentTargetUri,
  onCallButtonClick
}: CallButtonProps): JSX.Element {
  const { takingCalls, offline, arrangeCalls, offlineWithArrangeCalls } =
    ADVISOR_AVAILABILITY.callAvailability;

  const getCallButtonUrl = () => {
    let targetUrl = `
      /calls/initiatecallstarter.aspx
      ?sid=${listingId}
      &pmode=${pmode ? '1' : '0'}
      &ReturnUrl=${returnUrl}
      &CancelUrl=${cancelUrl}
      &WebTrack=${webTrack}
      &dpr=${displayPrice ? '1' : '0'}
      &mrp=${majorRank}
      &dooneclickcall=1
    `
      .replaceAll('\n', '')
      .replaceAll(' ', '');
    if (flBidId > 0 && eligibleForFeaturedListingClicks)
      targetUrl += `&FL=${flBidId}&category=${parentCategoryId}`;
    if (
      (majorRank === 3 || majorRank === 7 || majorRank === 11) &&
      appointmentTargetUri
    )
      targetUrl = appointmentTargetUri;
    return targetUrl;
  };

  const onButtonClick = (availability) => {
    if (onCallButtonClick) onCallButtonClick(availability);
    window.location.assign(getCallButtonUrl());
  };

  switch (callAvailability) {
    case takingCalls:
      return (
        <Button
          variant="primary"
          disableElevation
          size="medium"
          fullWidth
          startIcon={<CallIcon className="icon" />}
          onClick={() => onButtonClick(callAvailability)}>
          Call Now
        </Button>
      );
    case offline:
      return (
        <Button
          className="send-mail"
          variant="outlined"
          disableElevation
          size="medium"
          fullWidth
          startIcon={
            <EmailSharpIcon className="icon" sx={{ fill: '#09b3b0' }} />
          }
          onClick={() => onButtonClick(callAvailability)}>
          Send Mail
        </Button>
      );
    case arrangeCalls:
    case offlineWithArrangeCalls:
    default:
      return (
        <Button
          className="arrange-call"
          variant="outlined"
          disableElevation
          size="medium"
          fullWidth
          startIcon={<CallIcon className="icon" />}
          onClick={() => onButtonClick(callAvailability)}>
          Arrange Call
        </Button>
      );
  }
}

CallButton.defaultProps = {
  onCallButtonClick: null
};
